import { render, staticRenderFns } from "./item-scores.vue?vue&type=template&id=a16da7f8&scoped=true"
import script from "./item-scores.vue?vue&type=script&lang=js"
export * from "./item-scores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16da7f8",
  null
  
)

export default component.exports